export const AI_PLATFORM_URL = 'https://app.luoboielts.com/';
const footerLinkLabels = new Set(['AI 写作批改', 'AI 带写作文']);
export function applyCanonicalAiPlatformUrl(snapshot) {
    return {
        ...snapshot,
        brand: {
            ...snapshot.brand,
            aiPlatformUrl: AI_PLATFORM_URL,
        },
        home: {
            ...snapshot.home,
            aiProducts: snapshot.home.aiProducts.map((product) => ({
                ...product,
                target: product.target.kind === 'external'
                    ? { ...product.target, url: AI_PLATFORM_URL }
                    : product.target,
            })),
        },
        footer: snapshot.footer.map((section) => ({
            ...section,
            links: section.links.map((link) => footerLinkLabels.has(link.label) ? { ...link, href: AI_PLATFORM_URL } : link),
        })),
    };
}
//# sourceMappingURL=ai-platform.js.map